import { configureStore } from "@reduxjs/toolkit";
import UserDetailsSlice from "../Redux/UserDetails";
import CourseDetailsSlice from "../Redux/CourseDetails";
import learnersReportReducer from "../Redux/LearnersReport";
import CourseFeedbackReducer from "../Redux/CourseFeedback";
import { IgniteTalksslice } from "../Redux/IgniteTalks";
import VideoUploadReducer from "../Redux/VideoUpload";
import hallOfFameReducer from "../Redux/HallOfFame";
import adminAnalyticsReducer from "../Redux/AdminAnalytics";

export default configureStore({
  reducer: {
    userDetails: UserDetailsSlice,
    courseDetails: CourseDetailsSlice,
    learnersReport: learnersReportReducer,
    IgniteTalks: IgniteTalksslice.reducer,
    CourseFeedback: CourseFeedbackReducer,
    VideoUpload: VideoUploadReducer,
    hallOfFame: hallOfFameReducer,
    adminAnalytics: adminAnalyticsReducer,
  },
});
